import { IconChevronLeft16 } from '@warp-ds/icons/react/chevron-left-16';
import { IconChevronRight16 } from '@warp-ds/icons/react/chevron-right-16';
import cn from 'classnames';
import { useCallback, useRef, useState } from 'react';
import type { FeaturedAd } from './FeaturedAdCard';
import { FeaturedAdCard } from './FeaturedAdCard';
import styles from './FeaturedAdsCarousel.module.css';

type FeaturedAdsCarouselProps = {
    featuredAds: FeaturedAd[] | null;
    loginId?: string | null;
};

const CARD_WIDTH = 280;
const GAP = 16;
const SCROLL_AMOUNT = CARD_WIDTH + GAP;

export const FeaturedAdsCarousel = ({ featuredAds, loginId }: FeaturedAdsCarouselProps) => {
    const scrollRef = useRef<HTMLDivElement>(null);
    const [showPrev, setShowPrev] = useState(false);
    const [showNext, setShowNext] = useState(true);

    const updateButtons = useCallback(() => {
        const el = scrollRef.current;
        if (!el) return;
        setShowPrev(el.scrollLeft > 0);
        setShowNext(el.scrollLeft < el.scrollWidth - el.clientWidth - 1);
    }, []);

    const scroll = useCallback((direction: 1 | -1) => {
        scrollRef.current?.scrollBy({ left: direction * SCROLL_AMOUNT, behavior: 'smooth' });
    }, []);

    if (!featuredAds?.length) return null;

    return (
        <section className="my-32 mx-16 md:mx-0">
            <h2 className="h3">Sikre sommerferien f&oslash;r det er for sent</h2>
            <div className={styles.carouselContainer}>
                {showPrev && (
                    <button
                        type="button"
                        onClick={() => scroll(-1)}
                        className={cn(styles.navButton, styles.navButtonPrev)}
                        aria-label="Forrige">
                        <IconChevronLeft16 aria-hidden />
                    </button>
                )}
                <section className={styles.scrollContainer} ref={scrollRef} onScroll={updateButtons}>
                    <h3 className="sr-only">Anbefalte annonser</h3>
                    {featuredAds.map((ad) => (
                        <FeaturedAdCard key={ad.itemId} ad={ad} loginId={loginId} />
                    ))}
                </section>
                {showNext && (
                    <button
                        type="button"
                        onClick={() => scroll(1)}
                        className={cn(styles.navButton, styles.navButtonNext)}
                        aria-label="Neste">
                        <IconChevronRight16 aria-hidden />
                    </button>
                )}
            </div>
        </section>
    );
};
